import { apiClient } from '@/services/ApiClient.js'

export default {
  getSupplierDrivers(supplierId) {
    return apiClient
      .get('suppliers/' + supplierId + '/supplier-drivers')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSupplierDriver(supplierId, supplierDriver) {
    let formData = new FormData()
    formData.append('json_body', JSON.stringify(supplierDriver))
    if (supplierDriver.file) {
      formData.append('file', supplierDriver.file)
    }

    return apiClient
      .postForm('suppliers/' + supplierId + '/supplier-drivers', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSupplierDriver(supplierId, supplierDriverId, supplierDriver) {
    let formData = new FormData()
    formData.append('_method', 'PATCH')
    formData.append('json_body', JSON.stringify(supplierDriver))
    formData.append('file', supplierDriver.file)

    return apiClient
      .postForm('suppliers/' + supplierId + '/supplier-drivers/' + supplierDriverId, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteSupplierDriver(supplierId, supplierDriverId) {
    return apiClient
      .delete('suppliers/' + supplierId + '/supplier-drivers/' + supplierDriverId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierDriverInformationByTckn(tckn) {
    return apiClient
      .get('suppliers/drivers/information-by-tckn/', {
        params: {
          tckn: tckn
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierDriverInformationByPhone(phone) {
    return apiClient
      .get('suppliers/drivers/information-by-phone/', {
        params: {
          phone: phone
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
